'use strict';

;( function() {

	document.addEventListener( 'DOMContentLoaded', function() {

		var section      = document.querySelector( '.front-page-air-surface-undersea' );
		var desktopCards = Array.from( document.querySelectorAll( '[data-wave-desktop]' ) );
		var mobileCards  = Array.from( document.querySelectorAll( '[data-wave-mobile]' ) );

		var ALL_STATES = ['card-idle', 'card-active', 'card-prev', 'card-future'];

		desktopCards.sort( function( a, b ) {
			return parseInt( a.getAttribute( 'data-wave-desktop' ) ) - parseInt( b.getAttribute( 'data-wave-desktop' ) );
		});

		function clearDesktopFontSize() {
			desktopCards.forEach( function( card ) {
				card.style.removeProperty( '--font-size' );
			});
		}

		function hasCardContent( card ) {
			var content = card.firstElementChild;
			return !! ( content && content.textContent && '' !== content.textContent.trim() );
		}

		function getPreferredDesktopFontSize() {
			var minViewport = 1024;
			var maxViewport = 1600;
			var minSize     = 16;
			var maxSize     = 24;
			var viewport    = Math.max( minViewport, Math.min( maxViewport, window.innerWidth ) );
			var ratio       = ( viewport - minViewport ) / ( maxViewport - minViewport );

			return minSize + ( ratio * ( maxSize - minSize ) );
		}

		function setDesktopFontSize( cards, size ) {
			cards.forEach( function( card ) {
				card.style.setProperty( '--font-size', size.toFixed( 2 ) + 'px' );
			});
		}

		function cardsOverflowVertically( cards ) {
			return cards.some( function( card ) {
				var content = card.firstElementChild;
				var maxHeight = Math.floor( card.clientHeight * 0.8 );

				if ( ! content || 0 >= maxHeight ) {
					return false;
				}

				return content.scrollHeight > ( maxHeight - 1 );
			});
		}

		function syncDesktopWaveCardTypeSize() {
			if ( ! window.matchMedia( '(min-width: 64rem)' ).matches ) {
				clearDesktopFontSize();
				return;
			}

			var sizedCards = desktopCards.filter( hasCardContent );

			if ( ! sizedCards.length ) {
				return;
			}

			var preferredSize = getPreferredDesktopFontSize();
			var minSize       = 14;
			var low           = minSize;
			var high          = preferredSize;
			var i             = 0;

			for ( i = 0; i < 12; i++ ) { // eslint-disable-line
				var mid = ( low + high ) / 2;
				setDesktopFontSize( sizedCards, mid );

				if ( cardsOverflowVertically( sizedCards ) ) {
					high = mid;
				} else {
					low = mid;
				}
			}

			setDesktopFontSize( sizedCards, low );
		}

		var waveTypeResizeRaf = null;

		function scheduleWaveCardTypeSync() {
			if ( null !== waveTypeResizeRaf ) {
				window.cancelAnimationFrame( waveTypeResizeRaf );
			}

			waveTypeResizeRaf = window.requestAnimationFrame( function() {
				syncDesktopWaveCardTypeSize();
				waveTypeResizeRaf = null;
			});
		}

		function setCardState( card, state ) {
			ALL_STATES.forEach( function( cls ) {
				card.classList.remove( cls );
			});
			card.classList.add( state );
		}

		/* ==========================================
			DESKTOP: LAZY REVEAL (one-time slide up)
		========================================== */
		var revealedCount = 0;

		function handleDesktopReveal() {
			if ( revealedCount >= desktopCards.length ) return;

			var rect     = section.getBoundingClientRect();
			var windowH  = window.innerHeight;
			var progress = ( windowH - rect.top ) / ( windowH + rect.height );
			progress = Math.max( 0, Math.min( 1, progress ) );

			var thresholds = [0.10, 0.30, 0.50];

			for ( var i = revealedCount; i < desktopCards.length; i++ ) {
				if ( progress > thresholds[i] ) {
					desktopCards[i].classList.add( 'is-revealed' );
					revealedCount = i + 1;
				} else {
					break;
				}
			}
		}

		/* ==========================================
			DESKTOP: SCROLL HIGHLIGHT
		===========================================*/
		var lastActiveIndex = -2;

		function handleDesktopHighlight() {
			var rect     = section.getBoundingClientRect();
			var windowH  = window.innerHeight;
			var progress = ( windowH - rect.top ) / ( windowH + rect.height );
			progress = Math.max( 0, Math.min( 1, progress ) );

			var activeIndex = -1;
			if ( 0.12 < progress && 0.38 >= progress ) {
				activeIndex = 0; // Air
			} else if ( 0.38 < progress && 0.62 >= progress ) {
				activeIndex = 1; // Surface
			} else if ( 0.62 < progress ) {
				activeIndex = 2; // Undersea
			}

			if ( activeIndex === lastActiveIndex ) return;
			lastActiveIndex = activeIndex;

			desktopCards.forEach( function( card, i ) {
				if ( -1 === activeIndex ) {
					setCardState( card, 'card-idle' );
				} else if ( i === activeIndex ) {
					setCardState( card, 'card-active' );
				} else if ( i < activeIndex ) {
					setCardState( card, 'card-prev' );
				} else {
					setCardState( card, 'card-future' );
				}
			});
		}

		/* ==========================================
			DESKTOP: Combined scroll handler
		========================================== */
		if ( desktopCards.length && section ) {
			var ticking = false;
			window.addEventListener( 'scroll', function() {
				if ( ! ticking ) {
					window.requestAnimationFrame( function() {
						handleDesktopReveal();
						handleDesktopHighlight();
						ticking = false;
					});
					ticking = true;
				}
			}, { passive: true });

			handleDesktopReveal();
			handleDesktopHighlight();
		}

		scheduleWaveCardTypeSync();
		window.addEventListener( 'resize', scheduleWaveCardTypeSync, { passive: true });
		window.addEventListener( 'orientationchange', scheduleWaveCardTypeSync, { passive: true });
		window.addEventListener( 'load', scheduleWaveCardTypeSync );

		if ( document.fonts && document.fonts.ready ) {
			document.fonts.ready.then( scheduleWaveCardTypeSync );
		}

		/* ==========================================
			MOBILE: LAZY REVEAL (one-time)
		========================================== */
		if ( mobileCards.length ) {
			var mobileRevealObserver = new IntersectionObserver( function( entries ) {
				entries.forEach( function( entry ) {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'is-revealed' );
						mobileRevealObserver.unobserve( entry.target );
					}
				});
			}, {
				threshold : 0.2,
				rootMargin: '0px 0px -5% 0px',
			});

			mobileCards.forEach( function( card ) {
				mobileRevealObserver.observe( card );
			});
		}

		/* ==========================================
			MOBILE: SCROLL HIGHLIGHT
		========================================== */
		if ( mobileCards.length ) {
			var mobileHighlightObserver = new IntersectionObserver( function( entries ) {
				entries.forEach( function( entry ) {
					if ( entry.isIntersecting ) {
						setCardState( entry.target, 'card-active' );

						mobileCards.forEach( function( card ) {
							if ( card !== entry.target ) {
								var cardOrder   = parseInt( card.getAttribute( 'data-wave-mobile' ) );
								var activeOrder = parseInt( entry.target.getAttribute( 'data-wave-mobile' ) );
								if ( cardOrder < activeOrder ) {
									setCardState( card, 'card-prev' );
								} else {
									setCardState( card, 'card-future' );
								}
							}
						});
					}
				});
			}, {
				threshold : 0.5,
				rootMargin: '0px 0px -15% 0px',
			});

			mobileCards.forEach( function( card ) {
				mobileHighlightObserver.observe( card );
			});
		}
	});
})();
